import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetDeleteTreeNodeRequest extends BaseServiceRequest {
    constructor(nodeIds) {
        super();
        super.addRequestUri("removetreenodes.pb");
        super.addRequestParameter("nodeIds", nodeIds);
    }

    getMethod() {
        return HttpMethodType.PUT;
    }

    getSubSystem() {
        return SubSystemType.LIST;
    }

    getMessageName() {
        return "Response";
    }
}
export default GetDeleteTreeNodeRequest;